module.exports = __webpack_public_path__ + "static/media/banner_SPclient_mobile.f4108b77.png";